import { Box, Typography, styled } from "@mui/material";
import "../../theme/muiTypes.d.ts";

export const CheckboxContainer = styled(Box)(() => ({
  display: "flex",
  alignItems: "flex-start",
  gap: "8px",
  width: "100%",
}));

export const CheckboxLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.text?.primary || "#1B252F",
  fontSize: "14px",
  fontFamily: "Nunito, sans-serif",
  fontWeight: 400,
  lineHeight: "20px",
  userSelect: "none",
  flex: 1,
}));
